import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConfig } from './app.config';
import { LandingComponent } from './landing/landing.component';
import { AboutComponent } from './pages/about/about.component';
import { MobileAlertComponent } from './pages/alerts/mobile-alert/mobile-alert.component';
import { ContactComponent } from './pages/contact/contact.component';
import { HomeComponent } from './pages/home/home.component';
import { IndustryComponentsModule } from './pages/industries/components/industry-components.module';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { FooterComponent } from './shared/footer/footer.component';
import { LoadingModule } from './shared/loader/loading.module';
import { SharedModule } from './shared/shared.module';
import { UiComponentsModule } from './shared/ui-components/ui-components.module';
import { StormwarningsComponent } from './stormwarnings/stormwarnings.component';
@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    HomeComponent,
    FooterComponent,
    ContactComponent,
    PrivacyPolicyComponent,
    StormwarningsComponent,
    MobileAlertComponent,
    LandingComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    IndustryComponentsModule,
    UiComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    RecaptchaModule, // Import reCAPTCHA module
    RecaptchaFormsModule, // If using reactive forms
    LoadingModule,
  ],
  providers: [
    AppConfig,
    { provide: 'PORTAL_URL', useValue: environment.portal_url },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
